import React from 'react';

const I18nContext = React.createContext({
  lang: 'en',
  translation: {},
});

export default I18nContext;



// WEBPACK FOOTER //
// ./src/i18n/i18n-context.js